import {
  createContext,
  useContext,
  useState,
  useMemo,
  memo,
  ReactNode,
} from "react";

const LayerContext = createContext<any>(null);
export const useLayerContext = () => useContext(LayerContext);

const LayerProvider = ({ children }: { children: ReactNode }) => {
  const [layerSelectedNodeId, setLayerSelectedNodeId] = useState<string>("");

  const contextValue = useMemo(
    () => ({
      layerSelectedNodeId,
      setLayerSelectedNodeId ,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [layerSelectedNodeId]
  );

  return (
    <LayerContext.Provider value={contextValue}>
      {children}
    </LayerContext.Provider>
  );
};

export default memo(LayerProvider);
